var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9948 9.99646V12.6622C13.9948 13.0157 13.8543 13.3547 13.6044 13.6047C13.3544 13.8546 13.0154 13.995 12.6619 13.995H3.33188C2.97839 13.995 2.63937 13.8546 2.38941 13.6047C2.13945 13.3547 1.99902 13.0157 1.99902 12.6622V9.99646",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66504 6.66431L7.99719 9.99646L11.3293 6.66431",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 9.99643V1.99927",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.595bdafc04b9ea0a18d33125ee4c8c07.svg";
export { ForwardRef as ReactComponent };